import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ApplicationService } from '@app/services/application/application.service';
import { StateService } from '@app/services/state/state.service';
import { StorageService } from '@app/services/storage/storage.service';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BaseModalDirective } from '../base-modal';

@Component({
  selector: 'nh-medical-appeal-ineligible',
  templateUrl: './medical-appeal-ineligible.component.html',
  styleUrls: ['./medical-appeal-ineligible.component.scss'],
  standalone: false
})
export class MedicalAppealIneligibleComponent extends BaseModalDirective implements OnInit {
  translatedLang: any;
  defaultLanguage: any;
  applicationNum: any;
  constructor(protected modalRef: BsModalRef, protected builder: FormBuilder, public translateService: TranslateService, private router: Router,
    private application: ApplicationService,
    private storageService: StorageService,
    private stateService: StateService
  ) {
    super(modalRef, builder);
  }


  ngOnInit() {
    this.defaultLanguage = this.translateService.getDefaultLang();
    this.translatedLang = this.defaultLanguage;
    this.translateService.onDefaultLangChange.subscribe((res) => {
      this.defaultLanguage = res.lang
      this.translatedLang = this.defaultLanguage;
    });
  }

  onCancel(): void {
    this.hide('');
  }

  fileEliigibilityAppeal(appType: string) {
    this.hide('');
    this.application.getHeadOfHouseholdInfo(0, 'APL', 'APL').subscribe((res: any) => {
      this.applicationNum = res?.applicationNumber;
      if (sessionStorage.getItem('removedAppealRecord')) {
        sessionStorage.removeItem('removedAppealRecord')
      }
      if (this.applicationNum && this.storageService.getAppNumber() !== this.applicationNum) {
        sessionStorage.setItem('appNum', this.applicationNum);
        this.storageService.setAppNumber(this.applicationNum);
      }
      if (this.applicationNum && this.applicationNum !== '0' && this.applicationNum !== 0) {
        this.stateService.resetStates();
        this.application.deleteApp(this.applicationNum, 'TCAPL').subscribe(() => {
          sessionStorage.setItem('appNum', null);
          this.storageService.setApplicationType(appType);
          this.router.navigateByUrl('/application/' + 'NEW');
        })
      }
      else {
        this.stateService.resetStates();
        sessionStorage.setItem('appNum', null);
        this.storageService.setApplicationType(appType);
        this.router.navigateByUrl('/application/' + 'NEW');
      }
    });
  }
}
